import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Perfil", href: "#perfil" },
  { label: "Estadísticas", href: "#estadisticas" },
  { label: "Trayectoria", href: "#trayectoria" },
  { label: "Galería", href: "#galeria" },
  { label: "Videos", href: "#videos" },
  { label: "Contacto", href: "#contacto" },
];

export const LOGO_HORIZONTAL = "/logo-horizontal.webp";
export const LOGO_MONOGRAMA = "/logo-monograma.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (e, href) => {
    e.preventDefault();
    setOpen(false);
    if (window.__lenis) window.__lenis.scrollTo(href, { offset: -70 });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "bg-[#050505]/85 backdrop-blur-xl border-b border-neutral-800" : "bg-transparent"
      }`}
    >
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        <a href="#" data-testid="nav-logo" onClick={(e) => { e.preventDefault(); setOpen(false); window.__lenis?.scrollTo(0); }} className="flex items-center gap-3">
          <img src={LOGO_HORIZONTAL} alt="Cristian Díaz — logo oficial" className="h-9 w-auto" data-testid="logo-mark" />
          <span className="font-display font-black uppercase tracking-widest text-sm hidden sm:block">
            <span className="text-[#d4af37]">N°42</span>
          </span>
        </a>

        <ul className="hidden sm:flex items-center gap-2">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace("í", "i")}`}
                onClick={(e) => goTo(e, l.href)}
                className="font-tech text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-white px-3 py-2 transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          type="button"
          data-testid="nav-menu-button"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={open}
          className="sm:hidden text-neutral-200 hover:text-[#d4af37] transition-colors p-2"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="sm:hidden bg-[#050505]/95 backdrop-blur-xl border-b border-neutral-800">
          <ul className="px-6 py-4 flex flex-col">
            {links.map((l) => (
              <li key={l.href} className="border-b border-neutral-900 last:border-0">
                <a
                  href={l.href}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase().replace("í", "i")}`}
                  onClick={(e) => goTo(e, l.href)}
                  className="block font-tech text-sm uppercase tracking-[0.25em] text-neutral-300 hover:text-[#d4af37] py-4 transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
